const nameEncode = (name) =>
  name
    ?.trim()
    .replace(/ /g, "-")
    .replace(/\%/g, "")
    .replace(/\&/g, "n")
    .replace(/\,/g, "")
    .replace(/\//g, "")
    .replace(/\#/g, "")
    .replace(/\(/g, "")
    .replace(/\)/g, "")
    .replace(/\'/g, "")
    .replace(/\"/g, "")
    .replace(/\:/g, "")
    .replace(/\?/g, "")
    .replace(/\’/g, "")
    .replace(/\‘/g, "")
    .toLowerCase();

const getSpotLink = (type, name, key) => {
  if (type === "hotSpot") {
    return `https://www.ecohubmap.com/hot-spot/${nameEncode(name)}/${key}`;
  }
  if (type === "greenSpot") {
    return `https://www.ecohubmap.com/green-spot/${nameEncode(name)}/${key}`;
  }

  return `https://www.ecohubmap.com/company/${type}/${nameEncode(name)}/${key}`;
};

const getOneNewsLink = (name, key, blog) =>
  `${process.env.REACT_APP_SITE_URL}/${blog ? "post" : "the-news"}/${nameEncode(
    name
  )}/${key}`;

export { getSpotLink, getOneNewsLink, nameEncode };
